import React from "react";
import { toast } from "react-toastify";

import Toast from "src/components/toast";

export const toastSuccess = (message: string) => {
  toast(<Toast.Sucess message={message} />, { closeButton: false });
};

export const toastFailure = (message: string, heading?: string) => {
  toast(<Toast.Failure message={message} heading={heading} />, { closeButton: false });
};

export const toastWarning = (message: string, heading?: string) => {
  toast(<Toast.warning message={message} heading={heading ?? "Heads up"} />, {
    closeButton: false,
  });
};
